import { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as IconBigminus } from "../Images/icon_bigminus.svg";
import { ReactComponent as IconBigplus } from "../Images/icon_bigplus.svg";

const PlusMinus = ({ value, setValue, updateQuantity = null }) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleMinusClick = () => {
    if (setValue) {
      if (value >= 1) setValue(value - 1);
    }
    if (updateQuantity) {
      if (value >= 1) updateQuantity(-1);
    }
  };

  const handlePlusClick = () => {
    if (setValue) {
      if (value < 999) setValue(value + 1);
    }
    if (updateQuantity) {
      if (value < 999) updateQuantity(1);
    }
  };

  const handleInputChange = (e) => {
    let newValue = e.target.value.replace(/[^0-9]/g, "");
    newValue =
      newValue === "" ? "" : Math.min(999, Math.max(0, Number(newValue)));
    setInputValue(newValue);
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (inputValue === "" || isNaN(inputValue)) {
      setInputValue(value);
    } else {
      setValue(Number(inputValue));

      const difference = Number(inputValue) - value;
      let change = 0;
      if (difference >= 0) change = Math.abs(difference);
      else if (difference < 0) change = 0 - Math.abs(difference);
      if (updateQuantity) updateQuantity(change);
    }
  };

  return (
    <StyledButton>
      <IconBigminus onClick={handleMinusClick} style={{ cursor: "pointer" }} />
      <StyledInput
        className="number center"
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={() => setIsFocused(true)}
        $isFocused={isFocused}
      />
      <IconBigplus
        onClick={handlePlusClick}
        style={{ cursor: "pointer", marginLeft: "auto" }}
      />
    </StyledButton>
  );
};

const StyledButton = styled.div`
  width: 190px;
  height: 48px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 47px 96px 47px;
  box-shadow: 0 0 0 1px #dadada;
  background-color: #ffffff;
  .number {
    font-family: "notoSans-medium";
    font-size: 18px;
    color: #222222;
  }
`;

const StyledInput = styled.input`
  outline: none;
  border: none;
  border-radius: 8px;
  justify-self: center;
  text-align: center;
  width: 80px;
  box-shadow: ${({ $isFocused }) =>
    $isFocused ? "inset 0 0 0 2px #1167ed" : ""};
`;

export default PlusMinus;
